// src/components/ClientPortalLayout.js

import React, { useState } from 'react'; // Removed useCallback as it's not used
import 'animate.css';

// Import Client Portal specific content components
import ClientPortalDashboard from './ClientPortalDashboard';
import ClientPortalCases from './ClientPortalCases';
import ClientPortalDocuments from './ClientPortalDocuments';
import ClientPortalInvoices from './ClientPortalInvoices';
import ClientPortalCommunicationLogs from './ClientPortalCommunicationLogs';
import ClientPortalTasks from './ClientPortalTasks';
import ClientPortalTimeExpenses from './ClientPortalTimeExpenses';

function ClientPortalLayout({
  currentUser,
  clients,
  cases,
  documents,
  timeEntries,
  expenseEntries,
  invoices,
  invoiceItems,
  communicationLogs,
  tasks,
  authAxios, // Pass authAxios for any client-side data fetching/actions
  showFormMessage, // Pass showFormMessage for client-side feedback
  handleLogout, // Pass logout function
}) {
  const [activeClientTab, setActiveClientTab] = useState('client-dashboard');

  return (
    <div className="client-portal-container d-flex flex-column vh-100">
      {/* Client Portal Horizontal Navigation Bar */}
      <nav className="client-portal-navbar navbar navbar-expand-lg navbar-dark bg-secondary rounded-lg shadow-sm mb-3 mx-3 mt-3">
        <div className="container-fluid">
          {/* Changed <a> to <button> for accessibility */}
          <button className="navbar-brand btn btn-link text-white" onClick={() => setActiveClientTab('client-dashboard')}>
            Client Portal
          </button>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#clientPortalNavbarNav" aria-controls="clientPortalNavbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="clientPortalNavbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-dashboard' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-dashboard')}>
                  <i className="bi bi-house-door me-2"></i> Dashboard
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-cases' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-cases')}>
                  <i className="bi bi-folder me-2"></i> Cases
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-documents' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-documents')}>
                  <i className="bi bi-file-earmark-text me-2"></i> Documents
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-invoices' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-invoices')}>
                  <i className="bi bi-currency-dollar me-2"></i> Invoices
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-communication' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-communication')}>
                  <i className="bi bi-chat-dots me-2"></i> Communication
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-tasks' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-tasks')}>
                  <i className="bi bi-check2-square me-2"></i> Tasks
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link btn ${activeClientTab === 'client-time-expenses' ? 'btn-primary' : 'btn-secondary'} rounded-pill text-white`} onClick={() => setActiveClientTab('client-time-expenses')}>
                  <i className="bi bi-clock-history me-2"></i> Time & Expenses
                </button>
              </li>
            </ul>
            {/* Logged-in user name and logout button for Client Portal */}
            {currentUser && (
              <div className="dropdown ms-auto">
                <button className="btn btn-outline-light text-white rounded-pill dropdown-toggle" type="button" id="dropdownMenuButtonClient" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="bi bi-person-circle me-2"></i> {currentUser.username} (Client)
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButtonClient">
                  <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Client Portal Main Content Area */}
      <div className="client-portal-main-content flex-grow-1 p-3 bg-light mx-3">
        {activeClientTab === 'client-dashboard' && (
          <ClientPortalDashboard
            currentUser={currentUser}
            clients={clients}
            cases={cases}
            documents={documents}
            invoices={invoices}
            tasks={tasks}
            communicationLogs={communicationLogs}
          />
        )}
        {activeClientTab === 'client-cases' && (
          <ClientPortalCases
            currentUser={currentUser}
            clients={clients}
            cases={cases}
          />
        )}
        {activeClientTab === 'client-documents' && (
          <ClientPortalDocuments
            currentUser={currentUser}
            clients={clients}
            documents={documents}
            cases={cases}
            authAxios={authAxios}
            showFormMessage={showFormMessage}
          />
        )}
        {activeClientTab === 'client-invoices' && (
          <ClientPortalInvoices
            currentUser={currentUser}
            clients={clients}
            invoices={invoices}
            invoiceItems={invoiceItems}
          />
        )}
        {activeClientTab === 'client-communication' && (
          <ClientPortalCommunicationLogs
            currentUser={currentUser}
            clients={clients}
            communicationLogs={communicationLogs}
            cases={cases}
          />
        )}
        {activeClientTab === 'client-tasks' && (
          <ClientPortalTasks
            currentUser={currentUser}
            clients={clients}
            tasks={tasks}
            cases={cases}
          />
        )}
        {activeClientTab === 'client-time-expenses' && (
          <ClientPortalTimeExpenses
            currentUser={currentUser}
            clients={clients}
            timeEntries={timeEntries}
            expenseEntries={expenseEntries}
            cases={cases}
          />
        )}
      </div>
    </div>
  );
}

export default ClientPortalLayout;
